// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'

if(language=='zh-CN'){
    document.getElementsByTagName('meta')[1].setAttribute('content',floralTripmeta[language])
    document.getElementsByTagName('meta')[2].setAttribute('content',floralTripkey[language])
    document.title = floralTripTitle[language];
}else{
    document.getElementsByTagName('meta')[1].setAttribute('content',floralTripmeta['USA'])
    document.getElementsByTagName('meta')[2].setAttribute('content',floralTripkey['USA'])
    document.title = floralTripTitle['USA'];
    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
}
$('.commonlanguage').html(commonlanguage[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
// $('.commonPaidInformation').html(commonPaidInformation[language]);
$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.teamLeaderName1').html(teamLeaderName1[language]);
$('.teamLeaderName2').html(teamLeaderName2[language]);
$('.teamLeaderName3').html(teamLeaderName3[language]);
$('.teamLeaderZhiwei1').html(teamLeaderZhiwei1[language]);
$('.teamLeaderZhiwei2').html(teamLeaderZhiwei2[language]);
$('.teamLeaderZhiwei3').html(teamLeaderZhiwei3[language]);
$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.LeadershipIntro').html(LeadershipIntro[language]);
$('.teamLeaderDesc1').html(teamLeaderDesc1[language]);
$('.teamLeaderDesc2').html(teamLeaderDesc2[language]);
$('.teamLeader1').html(teamLeader1[language]);
$('.teamLeader2').html(teamLeader2[language]);
$('title').html(floralTripTitle1[language]);
$('.TalentRecruitment').html(TalentRecruitment[language])
$('.floralTrip_info p').html(floralAPPIntro[language])
$('.floralTrip_info h3').html(floralAPPMaxim[language])
$('.floralTrip_functions_title').html(floralFuncTitle[language])
$('.floralTrip_functions .fun1 p').html(floralReservation[language])
$('.floralTrip_functions .fun1 .span1').html(floralReservationDetail1[language])
$('.floralTrip_functions .fun1 .span2').html(floralReservationDetail2[language])
$('.floralTrip_functions .fun2 p').html(floralMembership[language])
$('.floralTrip_functions .fun2 .span1').html(floralMembershipDetail1[language])
$('.floralTrip_functions .fun2 .span2').html(floralMembershipDetail2[language])
$('.floralTrip_functions .fun2 .span3').html(floralMembershipDetail3[language])
$('.floralTrip_functions .fun3 p').html(floralGuides[language])
$('.floralTrip_functions .fun3 .span1').html(floralGuidesDetail1[language])
$('.floralTrip_functions .fun4 p').html(floralCommunity[language])
$('.floralTrip_functions .fun4 .span1').html(floralCommunityDetail1[language])
$('.floralTrip_functions .fun4 .span2').html(floralCommunityDetail2[language])
$('.floralTrip_functions .fun4 .span3').html(floralCommunityDetail3[language])
$('.floralTrip_functions .fun4 .span4').html(floralCommunityDetail4[language])
$('.floralTrip_functions .fun5 p').html(floralEvents[language])
$('.floralTrip_functions .fun5 .span1').html(floralEventsDetail1[language])
$('.floralTrip_functions .fun5 .span2').html(floralEventsDetail2[language])
$('.floralTrip_functions .fun5 .span3').html(floralEventsDetail3[language])
$('.floralTrip_functions .fun6 p').html(floralTickets[language])
$('.floralTrip_functions .fun6 .span1').html(floralTicketsDetail1[language])
$('.floralTrip_functions .fun6 .span2').html(floralTicketsDetail2[language])
$('.floralTrip_functions .fun6 .span3').html(floralTicketsDetail3[language])
$('.floralReservation').html(floralReservation[language])
$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);



/** WEBPACK FOOTER **
 ** ./src/js/floralTripLanguage.js
 **/